// İSG uzmanı portalı — belge ekleme modallarının bitiş tarihi alanı (GL #7, plan D8). Görünürlük,
// zorunluluk (yıldız + `aria-required`) ve kural ipucu seçilen türün `expiryRule`'undan gelir
// (`useDocumentLinkType`); `NoExpiry` ya da tür seçilmemişken alan HİÇ render edilmez. Hata/ipucu
// `aria-describedby` ile bağlanır (`Field` bunu kendisi yapmaz).

import { Field, Input, fieldDescribedBy } from '@isgportal/shared';
import type { UseFormRegisterReturn } from 'react-hook-form';
import type { DocumentLinkType } from './documentLinkForm';

export interface ValidUntilFieldProps {
  id: string;
  label: string;
  rule: Pick<DocumentLinkType, 'showValidUntil' | 'requireValidUntil' | 'expiryHint'>;
  /** Çözülmüş alan hatası (kural `EndDateRequired` iken boş tarih). */
  error?: string;
  registration: UseFormRegisterReturn<'validUntil'>;
}

export function ValidUntilField({ id, label, rule, error, registration }: ValidUntilFieldProps) {
  if (!rule.showValidUntil) {
    return null;
  }
  return (
    <Field
      htmlFor={id}
      label={label}
      error={error}
      hint={rule.expiryHint}
      required={rule.requireValidUntil}
    >
      <Input
        id={id}
        type="date"
        invalid={Boolean(error)}
        aria-required={rule.requireValidUntil || undefined}
        aria-describedby={fieldDescribedBy(id, error, rule.expiryHint !== undefined)}
        {...registration}
      />
    </Field>
  );
}
